import { IOfferCard } from '../../../../types';
import { getOfferName } from '../../utils/getOfferName';

export const prepareTitle = (offerCard: IOfferCard) => offerCard.title || getOfferName(offerCard);
